<template>
    <div>
        <Table heading="Api List" :rows="apis" :columns="columns" :pagination="true">
            <!-- URI column with input for params -->
            <template #col-uri="{ row }">
                <div class="d-flex flex-column">
                    <span class="text-muted small">{{ row.uri }}</span>
                    <input v-model="row.params" class="form-control form-control-sm mt-1"
                        placeholder="Enter params..." />
                </div>
            </template>

            <!-- Action buttons -->
            <template #actions="{ row }">
                <button class="btn btn-outline-info btn-sm" @click="testApi(row)">
                    View Output
                </button>
            </template>
        </Table>

        <div class="modal fade" :class="{ show: showTokens }" :style="{ display: showTokens ? 'block' : 'none' }"
            tabindex="-1">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Output</h5>
                        <button type="button" class="btn-close" @click="showTokens = false"></button>
                    </div>
                    <div class="modal-body">
                        {{ JSON.stringify(apiResponse, null, 2) }}
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="showTokens = false">
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="showTokens" class="modal-backdrop fade show"></div>
    </div>
</template>

<script setup>
import { ref } from "vue";
import Table from "../../components/Table/Table.vue";

const showTokens = ref(false)

const columns = [
    { key: "description", label: "Description" },
    { key: "uri", label: "URI" },
];

const apis = ref([
    { id: 1, description: "Change Password", uri: "/Manageuserajax", params: "" },
    { id: 2, description: "Get Countries", uri: "/Manageuserajax", params: "" },
    { id: 3, description: "Get Timezones", uri: "/Manageuserajax", params: "" },
    { id: 4, description: "Get Menu", uri: "/Personajax/", params: "" },
    // ... add rest of your APIs here
]);

const apiResponse = ref(null);

const testApi = async (row) => {
    try {
        const response = await fetch(row.uri, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ params: row.params }),
        });
        apiResponse.value = await response.json();
    } catch (error) {
        apiResponse.value = { error: error.message };
    }
    previewTokens()
};

const previewTokens = () => {
    showTokens.value = true
}
</script>
